import { Component, output, Input, OnChanges, SimpleChanges, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
    GuestFormType,
    GuestManagementComponent
} from '@employee-pages/badge-request-page/employee-member-firm-visitor/add-guest/guest-management';
import { AutomaticCroppingService } from '@ui-app/services/automatic-cropping.service';
import { EmployeeBusinessService } from '../../../../core/services/business.service';
import { ImageService } from '@ui-app/services/image.service';
import { purposeOfVisitList, typeOfVisitList } from '@employee-pages/badge-request-page/non-deloitte-visitors/non-deloitte.const';
import { BadgeRequestCategoryEnum, NonDeloitteTypeOfVisitEnum, NonDeloittePurposeOfVisitEnum } from '@employee-models/data.enums';
import { REGEX_EMAIL_FORMAT, REGEX_PHONE_10DIGIT } from '@employee-models/common.enums';
import { ISearchEmployeeApprovers } from '@employee-models/common.models';
import { IGuestRequest } from '@employee-pages/badge-request-page/usi-employee-badge-forms';
import * as DataEnums from '../../../../../../../DBadgePrehire-app/src/app/models/data.enums';
import { UserRoleEnum } from '@employee-models/data.enums';
import { ConfirmModalComponent } from '@ui-app/modals/confirm-modal/confirm-modal.component';
import { EMPTY, filter, switchMap } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { InfoModalComponent } from '@ui-app/modals/info-modal/info-modal.component';
import { Router } from '@angular/router';
import { RoutesConfig } from '@employee-configs/routes.config';
import { ApiConfig } from '@employee-configs/api.config';
import { CommonConfig } from '@employee-configs/common.config';  // ADD THIS LINE


@Component({
    selector: 'employee-add-none-deloitte',
    templateUrl: './add-none-deloitte.component.html',
    styleUrl: './add-none-deloitte.component.less'
})
export class AddNoneDeloitteComponent extends GuestManagementComponent {

    guestAdded = output<any>();
    guestFormType = GuestFormType.ADD;
    @Input() entityOrFssId: number;
    @Input() entityOrFssName: string;
    @Output() formDirty = new EventEmitter<boolean>();
    typeOfVisitList = typeOfVisitList;
    purposeOfVisitList = purposeOfVisitList;
    FormBuilder: any;
    selectedApprovers: ISearchEmployeeApprovers[] = [];
    selectedIRCApprovers: ISearchEmployeeApprovers[] = [];
    isIRCApproverShown = false;
    title = 'Add new visitor';
    buttonSubmitTitle = 'Add visitor';
    addGuestForm: FormGroup;
    numbersOfDays: number;
    visitorHasLapTop = false;
    DisplayDate = 90;
    user: any;
    showVisitorType = true;
    today = new Date().toISOString().split('T')[0];
    @Input() isBadgeExtension: boolean = false;
    protected readonly BadgeRequestCategoryEnum = BadgeRequestCategoryEnum;
    attachmentsList: any[] = [];

     readonly uploadAttachmentConfig = {
    ...CommonConfig.fileUploadRestrictions.attachment,
    areaTitle: 'Drag & Drop files here or',
    customRestrictions: 'You can add multiple files with max size 5 MB each <br> Supported formats: PDF, XLS, DOC, PPT, JPEG, JPG, PNG, ZIP',
    maxFilesCount: 10, // Allow up to 10 files at once
    multiple: true, // ADD THIS LINE - enables multiple file selection
    errors: {
        filesCount: 'Maximum 10 files can be uploaded',
        faceRecognition: `The photo isn't individual or face isn't clear on the photo. Please, upload another photo`,
    },
};
    constructor(protected fb: FormBuilder,
        automaticCroppingService: AutomaticCroppingService,
        employeeBusinessService: EmployeeBusinessService,
        imageService: ImageService,
        private toastr: ToastrService,
        public router: Router

    ) {
        super(fb, automaticCroppingService, employeeBusinessService, imageService);
        this.employeeBusinessService.userProfileService.userData$.subscribe(data => this.user = data);
    }

    private _minDate: string;
    get minDate(): string {
        return this._minDate;
    }
    set minDate(value: string) {
        this._minDate = value;
    }
    get isPurposeVisible(): boolean {
        return this.addGuestForm.value.typeOfVisit === NonDeloitteTypeOfVisitEnum.Client;
    }

    get isSeniorManager(): boolean {
        return (this.user?.userRoleIds?.length ? this.user.userRoleIds : [this.user?.userRoleId]).includes(81)  || this.user?.isSeniorManagerAndAbove;
    }
    
    submit(): void {
        const formValue = {
            ...this.addGuestForm.value,
            visitStartDate: this.addGuestForm.value.visitStartDate.toString(),
            visitEndDate: this.addGuestForm.value.visitEndDate.toString(),
            approvers: this.isSeniorManager ? [this.user.userId] : this.addGuestForm.value.approvers,
            hasLapTop: this.addGuestForm.value.hasLapTop !== null ? this.addGuestForm.value.hasLapTop : false,
            // isBadgeExtension comes from form value (already included in ...this.addGuestForm.value)
            photoInfo: this.addGuestForm.value.photoInfo || {}
        } as any;
        
        if (formValue.isBadgeExtension) {
            formValue.photoInfo = {};
        }

        console.log('🚀 AddNoneDeloitte submit() - isBadgeExtension:', formValue.isBadgeExtension, 'photoInfo:', formValue.photoInfo);
        
        this.guestAdded.emit(formValue);
        this.resetForm();
    }

    createForm(): void {
        this.addGuestForm = this.fb.group({
            firstName: ['', [Validators.required]],
            lastName: ['', [Validators.required]],
            companyName: ['', [Validators.required]],
            email: ['', [Validators.required, Validators.pattern(REGEX_EMAIL_FORMAT)]],
            localCellNumber: ['', [Validators.required, Validators.pattern(REGEX_PHONE_10DIGIT)]],
            cardNumber: ['', this.isBadgeExtension ? [Validators.required, Validators.pattern(/^\d+$/)] : []],
            accessRequiredIds: [[], [Validators.required]],
            hasLapTop: [false],
            laptopMake: [''],
            laptopSerialNumber: [''],
            visitStartDate: ['', [Validators.required, this.validateNotBeforeToday]],
            visitEndDate: ['', [Validators.required, this.validateDateRange.bind(this)]],
            typeOfVisit: ['', [Validators.required]],
            typeOfVisitName: [''],
            purposeOfVisit: [''],
            purposeOfVisitName: [''],
            notification: [''],
            // entityOrFssId: [''],
            // entityOrFssName: [''],
            entityOrFssId: [this.entityOrFssId || ''],
            entityOrFssName: [this.entityOrFssName || ''],
            approvers: [[], [Validators.required]],
            approversFull: [[]], // internal
            ircApprovers: [[]],
            approversFullIRC: [[]], // internal
            photoInfo: [null],
            attachmentGuid: [null],
            isBadgeExtension: [this.isBadgeExtension || false] // Preserve badge extension flag
        });

        if (this.isSeniorManager) {
            this.addGuestForm.controls.approvers.clearValidators();
            this.addGuestForm.updateValueAndValidity();
        }

        let popupShown = false;

        this.subs = this.addGuestForm.valueChanges.subscribe((formValues) => {
            this.formChangeHandler();

            const isClient = formValues.typeOfVisit === NonDeloitteTypeOfVisitEnum.Client;
            const isBusiness = formValues.purposeOfVisit === NonDeloittePurposeOfVisitEnum.BusinessVisit;

            if (isClient && isBusiness && !popupShown) {
                popupShown = true;
                this.showBusinessVisitPopup();

                // Reset the flag after the popup is closed
                setTimeout(() => (popupShown = false), 5000);
            }

        });
    }

    handleIRCApproverShown(): void {
        const isClient = this.addGuestForm.value.typeOfVisit === DataEnums.NonDeloitteTypeOfVisitEnum.Client;
        const isAuditAssessment = this.addGuestForm.value.purposeOfVisit === DataEnums.NonDeloittePurposeOfVisitEnum.AuditAssessment;
        if (isClient && isAuditAssessment) {
            window.open(`https://dguest.deloitte.com/`, '_blank');
            window.location.assign(`https://${window.location.host}`);
        }

        /*if (isClient && isAuditAssessment) {
            this.isIRCApproverShown = true;
            this.addGuestForm.controls.ircApprovers.addValidators([Validators.required]);
            this.addGuestForm.updateValueAndValidity();
        } else {
            this.isIRCApproverShown = false;
            this.addGuestForm.controls.ircApprovers.clearValidators();
            this.addGuestForm.controls.approversFullIRC.setValue([]);
            this.addGuestForm.controls.ircApprovers.setValue([]);
            this.addGuestForm.updateValueAndValidity();
        }*/
    }

    handleClientVisit(): void {
        const isClient = this.addGuestForm.value.typeOfVisit === NonDeloitteTypeOfVisitEnum.Client;
        const isBusiness = this.addGuestForm.value.purposeOfVisit === NonDeloittePurposeOfVisitEnum.BusinessVisit;

        if (isClient && isBusiness) {
            this.showBusinessVisitPopup();
        }
    }


    showBusinessVisitPopup(): void {
        this.subs = this.employeeBusinessService.infoModalService
            .initModal(InfoModalComponent, {
                title: 'Client Visit - Business Purpose',
                description: 'Please use the Captivate application to submit a request for a Client Visit - Business Purpose.',
                buttonsTitle: {
                    confirm: 'Go To Captivate'
                }
            })
            .pipe(
                switchMap((action: boolean) => {
                    if (action) {
                        // OK clicked
                        this.navigateToMyProfile(this.user.userId);
                        window.open(ApiConfig.RedirectUrls.captivate, '_blank');
                    } else {
                        this.showVisitorType = false;
                        this.addGuestForm.patchValue({
                            typeOfVisit: '',
                            purposeOfVisit: ''
                        });
                        this.addGuestForm.updateValueAndValidity();
                        // Recreate after a short delay
                        setTimeout(() => {
                            this.showVisitorType = true;
                            // Optionally, set a value or perform other logic here
                        });
                    }
                    return EMPTY;
                })
            )
            .subscribe(() => {
                this.employeeBusinessService.infoModalService.closeAllModals();
            });
    }

    navigateToMyProfile(userId: number): void {
        this.router.navigate([RoutesConfig.pages.employeeProfile, userId]);
    }


    setApprovers(approverIds: number[]): void {
        const previousApprovers = this.addGuestForm.value.approvers || [];
        this.addGuestForm.patchValue({
            approvers: approverIds
        });
        if (approverIds.length !== previousApprovers.length) {
            this.addGuestForm.markAsDirty();
        }
        this.formChangeHandler();
    }

    setFullApprovers(approvers: ISearchEmployeeApprovers[]): void {
        const previousApprovers = this.addGuestForm.value.approversFull || [];
        this.addGuestForm.patchValue({
            approversFull: approvers
        });
        if (approvers.length !== previousApprovers.length) {
            this.addGuestForm.markAsDirty();
        }
        this.formChangeHandler();
    }

    setIRCApprovers(approverIds: number[]): void {
        const previousApprovers = this.addGuestForm.value.ircApprovers || [];
        this.addGuestForm.patchValue({
            ircApprovers: approverIds
        });
        if (approverIds.length !== previousApprovers.length) {
            this.addGuestForm.markAsDirty();
        }
        this.formChangeHandler();
    }

    setFullIRCApprovers(approvers: ISearchEmployeeApprovers[]): void {
        const previousApprovers = this.addGuestForm.value.approversFullIRC || [];
        this.addGuestForm.patchValue({
            approversFullIRC: approvers
        });
        if (approvers.length !== previousApprovers.length) {
            this.addGuestForm.markAsDirty();
        }
        this.formChangeHandler();
    }

    onTypeOfVisit(): void {
        const purpose = this.addGuestForm.get('purposeOfVisit');
        purpose.setValidators(this.isPurposeVisible ? [Validators.required] : []);
        const ircApprovers = this.addGuestForm.controls.ircApprovers;
        if (this.isPurposeVisible == false) {
            this.addGuestForm.controls.ircApprovers.setValue([]);
            this.addGuestForm.controls.approversFullIRC.setValue([]);
            ircApprovers.setValidators([]);
            ircApprovers.updateValueAndValidity();
            this.addGuestForm.updateValueAndValidity();
        }
        purpose.updateValueAndValidity();
    }

    validateDateRange(control: any): { [key: string]: boolean } | null {
        if (!this.addGuestForm) {
            return null;
        }
        
        const startDate = this.addGuestForm.get('visitStartDate')?.value;
        const endDate = control.value;
        
        if (!startDate || !endDate) {
            return null;
        }
        
        const start = new Date(startDate);
        const end = new Date(endDate);
        const diffTime = end.getTime() - start.getTime();
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        
        if (diffDays > 90) {
            return { maxDaysExceeded: true };
        }
        
        return null;
    }

    dateChanged(): void {
        const start = Date.parse(this.addGuestForm.value.visitStartDate);
        const end = Date.parse(this.addGuestForm.value.visitEndDate);
        
        if (start) {
            this.minDate = this.addGuestForm.value.visitStartDate;
        }
        
        if (start && end && start > end) {
            this.addGuestForm.patchValue({
                visitEndDate: null
            });
        }
        
        // Revalidate end date when start date changes
        this.addGuestForm.get('visitEndDate')?.updateValueAndValidity();
        
        this.calculateNumbersOfDays();
    }

    calculateNumbersOfDays(): void {
        if (!this.addGuestForm.value.visitStartDate) {
            return;
        }
        const startDate = new Date(this.addGuestForm.value.visitStartDate);
        const endDate = new Date(this.addGuestForm.value.visitEndDate);
        if (startDate) {
            this.minDate = startDate.toString();

        }
        if (startDate && endDate && (startDate <= endDate)) {
            const differenceInTime = endDate.getTime() - startDate.getTime();
            this.numbersOfDays = Math.max(1, Math.ceil(differenceInTime / (1000 * 3600 * 24)));
        }
    }

    formChangeHandler(): void {
        this.calculateNumbersOfDays();
    }

    setLaptopValidators(): void {
        const laptopSerialNumber = this.addGuestForm.controls.laptopSerialNumber;
        const laptopMake = this.addGuestForm.controls.laptopMake;
        if (this.addGuestForm.value.hasLapTop) {
            laptopMake.setValidators([Validators.required]);
            laptopSerialNumber.setValidators([Validators.required]);
        } else {
            laptopMake.setValidators([]);
            laptopSerialNumber.setValidators([]);
        }
        laptopMake.updateValueAndValidity();
        laptopSerialNumber.updateValueAndValidity();
    }
    //  ngOnChanges(changes: SimpleChanges) {
    //      if (changes.entityOrFssId) {
    //        this.addGuestForm.patchValue({ entityOrFssId: this.entityOrFssId });
    //        this.addGuestForm.patchValue({ entityOrFssName: this.entityOrFssName });
    //      }
    //      if (changes.entityOrFssName) {
    //        this.addGuestForm.patchValue({ entityOrFssId: this.entityOrFssId });
    //        this.addGuestForm.patchValue({ entityOrFssName: this.entityOrFssName });
    //      }
    //    }
    ngOnChanges(changes: SimpleChanges): void {
        if (changes.entityOrFssId || changes.entityOrFssName) {
            this.addGuestForm.patchValue({
                entityOrFssId: this.entityOrFssId,
                entityOrFssName: this.entityOrFssName
            });
        }
    }

    onAccessRequiredChange(accessRequiredIds: number[]): void {
        this.addGuestForm.patchValue({ accessRequiredIds });
        console.log('Add accessRequiredIds', accessRequiredIds);
        this.addGuestForm.markAsDirty();
        this.onFormChange();
    }
    onFormChange() {
        this.formDirty.emit(this.addGuestForm.dirty);
    }
    
    // ADD THESE METHODS AFTER LINE 393:

onAttachmentUpload(event: any[]): void {
    if (event.length > 0) {
        // Loop through all uploaded files (supports multiple selection)
        event.forEach(data => {
            const file = this.getFileFromPhotoData(data);
            // Add to attachments list
            this.attachmentsList.push(file);
        });
        
        // Update form with all attachment UIDs
        const attachmentGuids = this.attachmentsList.map(att => att.uId);
        this.addGuestForm.patchValue({
            attachmentGuid: attachmentGuids,
        });
        this.addGuestForm.markAsDirty();
    }
}

clearAttachment(index?: number): void {
    if (index !== undefined) {
        // Remove attachment at specific index
        this.attachmentsList.splice(index, 1);
        
        // Update form with remaining attachment UIDs
        const attachmentGuids = this.attachmentsList.length > 0 
            ? this.attachmentsList.map(att => att.uId) 
            : null;
        
        this.addGuestForm.patchValue({
            attachmentGuid: attachmentGuids,
        });
        this.addGuestForm.markAsDirty();
    } else {
        // Clear all attachments (for compatibility with parent class)
        this.attachmentsList = [];
        this.addGuestForm.patchValue({
            attachmentGuid: null,
        });
        this.addGuestForm.markAsDirty();
    }
}

    
}
